import { render, staticRenderFns } from "./FloorDetailView.vue?vue&type=template&id=50777118&scoped=true"
import script from "./FloorDetailView.vue?vue&type=script&lang=js"
export * from "./FloorDetailView.vue?vue&type=script&lang=js"
import style0 from "./FloorDetailView.vue?vue&type=style&index=0&id=50777118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50777118",
  null
  
)

export default component.exports